import { useCallback, useContext, useMemo, useState } from "react";
import { ClientBFFContext } from "../../providers";
import { CpfSignupContext } from "./cpf-signup.provider";

export const useFirstStepSignup = () => {
    const client = useContext(ClientBFFContext);
    const { setStep, newRegisterUser, setNewRegisterUser } = useContext(CpfSignupContext);
    const [cpf, setCpf] = useState<string>(newRegisterUser?.cpf_number || "");
    const [error, setError] = useState<{ message?: string } | undefined>();
    const [errorApi, setErrorApi] = useState<
        { message: string; isNextStepAllowed: boolean } | undefined
    >();
    const [isSubmitting, setIsSubmitting] = useState<boolean>(false);

    const onSubmit = useCallback(async () => {
        try {
            setNewRegisterUser((state) => ({
                ...state,
                cpf_number: cpf,
            }));
            setIsSubmitting(true);
            const response = await client.getExternalUserByCPFNumber(cpf);
            setNewRegisterUser((state) => ({
                ...state,
                ...response,
            }));
            setErrorApi(undefined);
            setStep("second");
        } finally {
            setIsSubmitting(false);
        }
    }, [setNewRegisterUser, setStep, client, cpf]);

    return useMemo(
        () => ({
            onSubmit,
            error,
            errorApi,
            isSubmitting,
            cpf,
            setCpf,
            setError,
            setErrorApi,
        }),
        [onSubmit, error, errorApi, isSubmitting, cpf, setCpf, setError, setErrorApi],
    );
};
